import React, {Component, useState, useEffect} from 'react'; 
import CareersContent from '../components/CareersContent';  
import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import withRouter from '../components/withRouter';
import CareerPages from '../components/CareerPages'; 
import { Helmet } from "react-helmet";
import {  base_url} from '../common/Constants';

class Careers extends React.Component{

    
    render()
    { 
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div class="body-block" data-v-e8f34808="">
                <div data-v-e8f34808="" class="page-block">
                <Header/>
                <Helmet>
                    <title>{metas[4].title}</title>  
                    <meta name="description" content={metas[4].meta_description} />
                    <meta name="keywords" content={metas[4].meta_title} />
                    <meta property="og:image" content={base_url+'assets/img/logo.png'}  />
                    <link rel="canonical" href={base_url+'careers'} />
                </Helmet>  
                <PageHeader title="Careers" banner={base_url+`assets/_nuxt/img/careers.078a756.jpg`} />
                <CareersContent content={JSON.parse(localStorage.getItem("content"))} careers={JSON.parse(localStorage.getItem("careers"))}  />  
                <CareerPages />
                <Footer/>
                </div>
      
        
        </div>
       
        )
    }

}
export default withRouter(Careers);;